import { Button } from 'alurkerja-ui';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { Section } from '@/components/shared/section/Section';

export const DiagramTask = () => {
  const navigate = useNavigate();

  const actionButton = () => (
    <div className="flex items-center gap-4">
      <Button icon={<ChevronLeft size={12} />} onClick={() => navigate(-1)}>
        Back
      </Button>
      BPMN
    </div>
  );

  return (
    <div className="border rounded">
      <Section title="Task" action={actionButton}>
        <div className="p-6">Diagram</div>
      </Section>
    </div>
  );
};
